import { useCallback, useState } from "react";
import { AxiosError, AxiosResponse } from "axios";
import { ICollection } from "../../../utils/interfaces/collection.interface";
import { handleBackendError } from "../../../utils/helpers";
import { useTranslation } from "react-i18next";
import { IPaginationParams } from "../../../utils/interfaces/pagination-params.interface";
import { IResource } from "../../../utils/interfaces/resource.interface";
import CustomerRepository from "../../../repositories/customer-repository";
import { CustomerList } from "../list/interface";
import { Customer } from "../../../models/customer";

export const useGetCustomer = () => {
  const { t } = useTranslation();
  const [data, setData] = useState<CustomerList[]>([]);
  const [totalData, setTotalData] = useState<number>(0);
  const [isOnFetchingData, setIsOnFetchingData] = useState<boolean>(false);

  const [customerData, setCustomerData] = useState<Customer | null>(null);
  const [isOnFetchingCustomerData, setIsOnFetchingCustomerData] =
    useState<boolean>(false);

  const loadData = useCallback(async (params: IPaginationParams) => {
    setIsOnFetchingData(true);

    await CustomerRepository.all(params)
      .then((response: AxiosResponse<ICollection<CustomerList[]>>) => {
        setData(response.data.data);
        setTotalData(response.data.meta.total);
      })
      .catch(() => {})
      .finally(() => {
        setIsOnFetchingData(false);
      });
  }, []);

  const loadCustomerData = useCallback(
    async (id: string, params: any = null) => {
      setIsOnFetchingCustomerData(true);

      await CustomerRepository.show(id, params)
        .then((response: AxiosResponse<IResource<Customer>>) => {
          setCustomerData(response.data.data);
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setIsOnFetchingCustomerData(false);
        });
    },
    [t]
  );

  return {
    data,
    totalData,
    loadData,
    isOnFetchingData,
    loadCustomerData,
    isOnFetchingCustomerData,
    customerData,
  };
};
